export function calculatePadWidth (precision) {
  return `${60 * precision}px`;
}